"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _default = function _default() {
  let prefix = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  return [_react.default.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.01 3c-.41 0-.77.12-1.05.4-.27.29-.39.67-.39 1.1 0 .29.05.56.18.79.13.23.3.41.52.53.22.12.47.18.72.18.41 0 .77-.12 1.04-.41.28-.29.39-.67.39-1.1 0-.29-.05-.55-.18-.79-.12-.22-.29-.4-.51-.52-.22-.12-.46-.18-.72-.18zm2.16 4.78c-.1-.45-.5-.78-.97-.78h-2.4c-.47 0-.87.33-.97.78L8 16h3v5h2v-5h3l-1.83-8.22z"
  })];
};

exports.default = _default;